import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

const useStyles = makeStyles({
  root: {
    paddingInline: '5px',
    width: '99px'
  }
});

export default function LinearProgressBar({
  fileProgress
}: {
  fileProgress?: number;
}) {
  const classes = useStyles();
  const [progress, setProgress] = React.useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        const diff = Math.random() * 10;

        return Math.min(oldProgress + diff, 90);
      });
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  const progressToDisplay =
    fileProgress === undefined ? progress : fileProgress;

  return (
    <div style={{ marginLeft: '25px' }}>
      <div className={classes.root}>
        <LinearProgress variant='determinate' value={progressToDisplay || 0} />
      </div>
    </div>
  );
}
